// {{BASE_URL}}/api/schemeType
import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

interface IGetCountriesOutput {
  country_id: number;
  code: string;
  description: string;
  numeric_code: number;
}

export const getAllCountries = async (): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/country`
  );

  let _data: IGetCountriesOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const getCountriesMemberState = async (
  excludeCyprus: boolean = false
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/country/member-state${
      excludeCyprus ? '?excludeCyprus=true' : ''
    }`
  );

  let _data: IGetCountriesOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const requestRegistrationInformation = async (
  schemeType: number,
  memberState: number,
  vatNumber?: string,
  tradeDate?: Date,
  intNumber?: string,
  contractRelationship?: boolean,
  vatTaxRef?: string,
  netpIntermediaryStatus?: string
) => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/registration/request`,
    {
      netpType: schemeType,
      memberState,
      vatNumber,
      tradeDate,
      intNumber,
      contractRelationship,
      vatTaxRef,
      netpIntermediaryStatus,
    }
  );

  let output: Types.ResponseOutput = {
    message: data.message,
    data: null,
    status: data.status,
  };
  return output;
};

export const requestVatReturnInformation = async (
  schemeType: number,
  memberState: number,
  vatNumber?: string,
  intNumber?: string,
  requestType?: 'MSOCN' | 'MSEST',
  vatReturnReference?: string,
  vatReturnVersion?: string,
  vatReturnPeriodQuarter?: number,
  vatReturnPeriodYear?: number,
  country?: number
) => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/vatreturn/request`,
    {
      netpType: schemeType,
      memberState,
      vatNumber,
      intNumber,
      requestType,
      vatReturnReference,
      vatReturnVersion,
      quarter: vatReturnPeriodQuarter,
      year: vatReturnPeriodYear,
      country,
    }
  );

  let output: Types.ResponseOutput = {
    message: data.message,
    data: null,
    status: data.status,
  };
  return output;
};
